// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"272":"maintenance","388":"result","445":"accessibility","571":"legal-notice","757":"not-found"}[chunkId] + "." + {"272":"837bae5e","388":"3b43c32b","445":"b109724e","571":"c354cf20","757":"837bae5e"}[chunkId] + ".css";
};